import React from 'react';
const highlights = ['THE productive turning solution for bar machining', 'Bar capacity 42 or 65 mm', 'Integrated robot-automation available for chucking operations', 'Real reduction of cycle time by simultaneous operations with three turrets (Triplex)', 'Two Y-axis (Triplex Version)', 'Each turret can work on both spindles → lowest cycle-time', 'Useful for complex turning and milling applications from bar material', 'For small, medium and large batch production', 'Quick and direct programming at the machine by conversational programming', 'Highly dynamic', 'High productivity', 'With affordable price for German technology'];
const mechanicalEngineering = ['Turret 1: X/Y/Z', 'Turret 2: X/Z', 'Turret 3: X/Y/Z', 'Free chip-flow', 'Full casting machine body with three-point base', 'Perfect covers for guideways', 'Live tools and C-axis as standard', 'Two full Y-axis in turret 1 and 3 fully integrated in machine design', 'Integrated motor spindles, liquid cooled', 'Integrated SPINNER anti-vibration system to increase cutting performance', 'Permanent three tool simultaneously cutting'];
export function SpecsSection() {
  return <div className="grid md:grid-cols-2 gap-12 mb-20" data-id="element-3881">
      <div data-id="element-3882">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3883">Highlights</h2>
        <ul className="space-y-3" data-id="element-3884">
          {highlights.map((item, index) => <li key={index} className="flex items-start" data-id="element-3885">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3886">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3887">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
      <div data-id="element-3888">
        <h2 className="text-2xl font-bold text-navy mb-6" data-id="element-3889">
          Mechanical Engineering
        </h2>
        <ul className="space-y-3" data-id="element-3890">
          {mechanicalEngineering.map((item, index) => <li key={index} className="flex items-start" data-id="element-3891">
              <span className="text-[#0077B6] mr-3 mt-1.5 text-xl leading-none" data-id="element-3892">
                •
              </span>
              <span className="text-gray-700 text-lg leading-relaxed" data-id="element-3893">
                {item}
              </span>
            </li>)}
        </ul>
      </div>
    </div>;
}